<template>
  <gc-main-layout
    :title="title"
    :isXSmall="isXSmall"
    :isLarge="isLarge"
    :baseView="baseView"
    :key="baseView.mode"
    :hot-key-create-path="'/product-filter-group/create'"
    :formsConfig="formsConfig"
    :backButtonEnable="true"
    :backButtonFunction="backButtonFunction"
  >
    <template #headerContent>
      <GcHeaderContentStatic title="Product Filter Groups" />
    </template>
    <div class="css-v2 transaction-list product-filter-group-list">
      <dx-data-grid
        :data-source="dataSourceConfig"
        @toolbar-preparing="onToolbarPreparing($event)"
        :height="gridHeight - 20"
        :columns="columns"
        @content-ready="addGridNoResults($event)"
        @cell-click="onMasterCellClick"
      >
        <template #product-filter-code-cell-template="{ data }">
          <GcDescriptionCodeCellTemplate
            :description="data.data.Description"
            :code="data.data.Code"
          />
        </template>
        <template #status-cell-template="{ data }">
          <gc-inactive :inactive="data.data.Inactive" />
        </template>
      </dx-data-grid>
    </div>
  </gc-main-layout>
</template>

<script>
import { ProductFilterGroupListService } from "../../../_services/api/settings/products/product-filter-group-list.service";

import BaseViewMixin from "../../../v1/_mixins/base.view";

const ds = ProductFilterGroupListService.dataSourceConfig({
  select: ["Code", "Description", "Type", "Inactive", "CreatedBy", "DateCreated"],
});

export default {
  props: {},
  mixins: [BaseViewMixin],
  data() {
    return {
      dataSourceConfig: ds,
      noDataMessage: {
        addNew: {
          class: "add-new",
          title: "No Filter Groups",
          message: "Get Started, Add a Filter Group",
        },
      },
    };
  },
  components: {},
  computed: {
    columns() {
      return this.parseGridColumns("master", [
        {
          gcLabel: "Product Filter Group",
          cellTemplate: "product-filter-code-cell-template",
          dataField: "Code",
          gcType: "String",
          gcSubType: "PrimaryRecord",
          sortOrder: "desc",
        },
        {
          gcLabel: "Type",
          dataField: "Type",
          gcType: "String",
          width: 200,
        },
        {
          gcLabel: "Date Created",
          dataField: "DateCreated",
          gcType: "Date",
        },
        {
          gcLabel: "Created By",
          dataField: "CreatedBy",
          gcType: "String",
          width: 150,
        },
        {
          dataField: "Inactive",
          gcType: "String",
          gcSubType: "Chip",
          cellTemplate: "status-cell-template",
        },
      ]);
    },
  },
  methods: {
    backButtonFunction() {
      this.$router.push({
        path: "/settings/products",
      });
    },
    onMasterCellClick(e) {
      this.$router.push({
        path: `/product-filter-group/review/${e.data.Code}`,
      });
    },
    onToolbarPreparing(e) {
      var toolbarItems = e.toolbarOptions.items;
      var searchPanel = toolbarItems.find((item) => {
        return item.name === "searchPanel";
      });

      var columnChooserButton = toolbarItems.find((item) => {
        return item.name === "columnChooserButton";
      });

      e.toolbarOptions.items = toolbarItems.filter((item) => {
        return (
          item.name !== "searchPanel" && item.name !== "columnChooserButton"
        );
      });

      searchPanel.location = "after";

      e.toolbarOptions.items.unshift(
        {
          location: "before",
          widget: "dxButton",
          options: {
            icon: "plus",
            text: "Add New",
            onClick: () => {
              this.$logger.trackEventButtonClickAddNew();
              this.$router.push({
                path: "/product-filter-group/create",
              });
            },
          },
        },
        searchPanel,
        columnChooserButton
      );
    },
  },
  created() {},
};
</script>

<style lang="scss">
.product-filter-group-list {
  .dx-button.dx-button-has-icon.dx-button-has-text[aria-label="Add New"] {
    height: 25px;
    .dx-button-content {
      padding: 3px;
    }
    .dx-icon {
      font-size: 12px;
      margin-right: 0px;
      padding: 0px;
    }
    .dx-button-text {
      font-size: 10px;
    }
  }
}
</style>
